/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:55:34
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";

// @uiAttrs - attach additional attrs to the component.

@UITag.set()
export class uiAttrs extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = false;

    /// set props from rule object
    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input);
        if (rule == null) return null;
        return {
            props: rule,
        };
    }
}
